module.exports = __webpack_public_path__ + "img/cashless-payment line.665a6680.svg";